export class EmailNotification {
  id: string;
  userId: string;
  title: string;
  body: string;
  icon: string;
  createdDate: Date | string;
  primaryId: string | null;
  secondaryId: string | null;
  optionalValue: string;
  jobId: string | null;
  isActionClicked: boolean;
}

export class EmailNotificationResult {
  emailNotifications: EmailNotification[];
  pageTotal: number;
}
